import { render, staticRenderFns } from "./ShowDocuments.vue?vue&type=template&id=af4b215a&scoped=true"
import script from "./ShowDocuments.vue?vue&type=script&lang=js"
export * from "./ShowDocuments.vue?vue&type=script&lang=js"
import style0 from "./ShowDocuments.vue?vue&type=style&index=0&id=af4b215a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4b215a",
  null
  
)

export default component.exports